module.exports = function (alg) {
  return "sha".concat(alg.substr(2, 3));
};